import { render, staticRenderFns } from "./Element.vue?vue&type=template&id=185449be&scoped=true&v-if=moveable&"
import script from "./Element.vue?vue&type=script&lang=js&"
export * from "./Element.vue?vue&type=script&lang=js&"
import style0 from "./Element.vue?vue&type=style&index=0&id=185449be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185449be",
  null
  
)

export default component.exports